/**
 |--------------------------------------------------------------------------
 | COMPANY CONTRACTS : Vue-Router Routes
 |--------------------------------------------------------------------------
 */
const company_contracts = [
 {
  path: '/contracts/all', component: require('pages/companies/contracts/all_contracts.vue').default,
  name: 'all_contracts',
  meta: {requiresAuth: true, title: "All Contracts", icon: "fas fa-file-contract"}
 },
 {
  path: '/contracts/all/expiring', component: require('pages/companies/contracts/all_expiring_contracts.vue').default,
  name: 'all_expiring_contracts',
  meta: {requiresAuth: true, title: "Expiring Contracts", icon: "fas fa-hourglass-half"}
 },
];
export default company_contracts;
